module.exports = __webpack_public_path__ + "web/img/img2.051986b7.png";